import { Protocol } from './index';
import { Category } from '../constants';

const indexer: Protocol[] = [
  {
    name: 'Ghost',
    url: 'https://tryghost.xyz',
    logoPath: '/logos/ghost.png',
    category: Category.Indexer,
    twitterUrl: 'https://twitter.com/0xGhostLogs',
  },
];

export { indexer };
